<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

if (window.location.hostname === "handicraftstown.in" && window.location.pathname === "/") {
  window.location.href = "https://handicraftstown.com/blogs/news/wall-paintings-for-living-room";
}


if (window.location.href.includes('cloth-stand')) {
    window.location.href = '/';
  }



  



  // resource is formatted as a page link product page 

  document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".jdgm-rev__pic-link").forEach(link => {

    link.setAttribute("href", "javascript:void(0)");

  });

});